import dynamic from "next/dynamic";

export const DynamicContent041 = dynamic(() => import("./Content041"), {
  suspense: true,
});
